import { Modal } from "antd";

/**
 * Hộp thoại xác nhận dùng chung cho toàn bộ trang danh sách.
 *
 * Thay cho `window.confirm` (dialog trắng của trình duyệt, không style được,
 * bị chặn trên một số webview) và cho các chỗ tự gọi `Modal.confirm` rời rạc.
 *
 * Trả về Promise<boolean> nên giữ nguyên được hình dạng code cũ:
 *
 *   const confirmed = await confirmDelete({ entity: "khách hàng", name: record.name });
 *   if (!confirmed) return;
 *
 * @param {object}  opts
 * @param {string}  opts.title
 * @param {import("react").ReactNode} opts.content
 * @param {string}  opts.okText
 * @param {string}  opts.cancelText
 * @param {string}  opts.okType     "primary" | "danger"
 * @returns {Promise<boolean>}
 */
export function confirmAction({
    title = "Xác nhận",
    content,
    okText = "Đồng ý",
    cancelText = "Hủy",
    okType = "primary",
} = {}) {
    return new Promise((resolve) => {
        Modal.confirm({
            title,
            content,
            okText,
            cancelText,
            okType,
            centered: true,
            maskClosable: false,
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
        });
    });
}

/**
 * Xác nhận xoá — bản rút gọn của confirmAction với tông "nguy hiểm".
 *
 * @param {object} opts
 * @param {string} opts.entity  Loại dữ liệu, ví dụ "khách hàng", "đợt thu".
 * @param {string} opts.name    Tên bản ghi (nếu có) để người dùng đối chiếu.
 * @param {import("react").ReactNode} opts.content  Ghi đè hoàn toàn phần nội dung.
 * @returns {Promise<boolean>}
 */
export function confirmDelete({ entity = "bản ghi", name, title, content } = {}) {
    const target = name ? `${entity} "${name}"` : `${entity} này`;

    return confirmAction({
        title: title ?? "Xác nhận xóa",
        content: content ?? `Bạn có chắc chắn muốn xóa ${target}? Hành động này không thể hoàn tác.`,
        okText: "Xóa",
        cancelText: "Hủy",
        okType: "danger",
    });
}
